// frontend/src/components/NewsCalendar.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadNews } from '../redux/slices/tradingSlice';
import { FaCalendar, FaClock, FaFlag } from 'react-icons/fa';

const NewsCalendar = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { news } = useSelector((state) => state.trading);
  const [selectedCurrency, setSelectedCurrency] = useState('all');
  const [selectedImpact, setSelectedImpact] = useState('all');

  useEffect(() => {
    if (user?.uid) {
      dispatch(loadNews(user.uid));
    }
  }, [user]);

  const getImpactColor = (impact) => {
    switch(impact) {
      case 'High': return '#ef4444';
      case 'Medium': return '#f59e0b';
      default: return '#10b981';
    }
  };

  const getImpactIcon = (impact) => {
    switch(impact) {
      case 'High': return '🔴';
      case 'Medium': return '🟡';
      default: return '🟢';
    }
  };

  const currencies = ['all', ...new Set(news.map(n => n.currency))];
  const impacts = ['all', 'High', 'Medium', 'Low'];

  const filteredNews = news.filter(item => {
    if (selectedCurrency !== 'all' && item.currency !== selectedCurrency) return false;
    if (selectedImpact !== 'all' && item.impact !== selectedImpact) return false;
    return true;
  });

  if (news.length === 0) {
    return (
      <div className="card">
        <div className="card-header">
          <h2>Economic Calendar</h2>
        </div>
        <p className="text-muted">Loading economic news...</p>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <h2><FaCalendar /> Economic Calendar</h2>
        <div className="news-filters">
          <select value={selectedCurrency} onChange={(e) => setSelectedCurrency(e.target.value)}>
            {currencies.map(c => (
              <option key={c} value={c}>{c === 'all' ? 'All Currencies' : c}</option>
            ))}
          </select>
          <select value={selectedImpact} onChange={(e) => setSelectedImpact(e.target.value)}>
            {impacts.map(i => (
              <option key={i} value={i}>{i === 'all' ? 'All Impacts' : i}</option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="news-list">
        {filteredNews.map((item, idx) => (
          <div key={idx} className="news-item" style={{ borderLeftColor: getImpactColor(item.impact) }}>
            <div className="news-time">
              <FaClock /> {new Date(item.time).toLocaleString()}
            </div>
            <div className="news-content">
              <div className="news-header">
                <span className="news-currency">{item.currency}</span>
                <span className="news-impact" style={{ color: getImpactColor(item.impact) }}>
                  {getImpactIcon(item.impact)} {item.impact} Impact
                </span>
              </div>
              <div className="news-event">{item.event}</div>
              <div className="news-details">
                {item.forecast && <span>Forecast: {item.forecast}</span>}
                {item.previous && <span>Previous: {item.previous}</span>}
                <span className="news-source">Source: {item.source}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsCalendar;